export default __webpack_public_path__ + "static/media/scrabble-2048w.d37c0375.png";